import React, {Fragment} from "react";
import {postData} from "../../../../utils/request";
import {CurrencyFormatter, ProductColumn, productTooltip, UnitFormatter} from "../../../../utils/formatters";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput} from "../../../../utils/other";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import StockEditor from "../../stockEditor";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import Select from "../../../form/Select";
import {get} from "../../../../utils/dotutils";
import OperationListStock from "../../OperationList/OperationListStock";

const filterable = true;
const sortable = true;

export default class Items extends React.Component {
    render() {
        const editableFields = this.props.editableFields || [];
        return (
            <SelectorGrid
                {...this.props.getFieldProps("allitems")}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                className={"p-small-table"}
                view={["id", "name", "qty", "unit", "listprice", "saleprice", "totalprice", "sku", "barcode", "product_id", "vat"]}
                addRowFunction={this.props.addRowFunction}
                onAddRows={(items) => {
                    return items.map((item) => {
                        item.product_id = item.id;
                        item.saleprice = item.saleprice !== undefined ? item.saleprice : item.listprice;
                        item.qty = item.qty || 1;
                        return item;
                    });
                }}
                onItemUpdate={async (item, oldItem, field, rowIndex, {listfieldComponentConfig}) => {
                    if (field === "discount") {
                        item.discount = parseFloat(item.discount);
                    }
                    if (field === "saleprice") {
                        item.saleprice = parseFloat(item.saleprice);
                    }
                    if (field === "netsaleprice") {
                        item.netsaleprice = parseFloat(item.netsaleprice);
                        const saleprice = item.netsaleprice * (1 + parseFloat(item.vat.rate));
                        item.discount = 100 - saleprice / item.listprice * 100; // discount
                        item.saleprice = saleprice;
                        //item.netsaleprice = 100 - item.netsaleprice / oldItem.netsaleprice * 100;
                    }
                    if (field === "totalprice") {
                        item.qty = parseFloat(item.qty);
                        item.totalprice = parseFloat(item.totalprice);
                        item.saleprice = item.totalprice / item.qty;
                    }
                    if (field === "discount") {
                        item.saleprice = item.listprice - Math.round(item.listprice / 100 * item.discount);
                    }
                    const updateItem = {};
                    Object.keys(listfieldComponentConfig.fielddefs).map((key) => {
                        updateItem[key] = item[key];
                    });
                    let actionparams = {
                        parentcomponent: this.props.componentConfig.componentname,
                        listfield: "allitems",
                        parentid: this.props.values[this.props.componentConfig.idfield],
                        action: "componentlist.updateItems",
                        items: [updateItem]
                    };
                    await postData(actionparams);
                    return true;
                }}
                aggregations={{
                    fields: {
                        "qty": {
                            field: "qty", type: "SUM"
                        },
                        "totalprice": {
                            field: "totalprice", type: "SUM"
                        },
                    }
                }}
                columns={{
                    "displayname": {
                        ...ProductColumn("product_id"),
                    },
                    "category.name": {
                        header: 'Árutípus',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "sku": {
                        header: 'ISBN',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "listprice": {
                        header: 'Fogyasztói ár',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: CurrencyFormatter,
                        className: "currency"
                    },
                    "discount": {
                        header: 'Kedvezmény',
                        width: 1,
                        className: "discount",
                        sortable,
                        renderer:
                            (value, purchaseitem) => {
                                return <span className="discount">{value + "%"}</span>;
                            },
                        editor:
                            (parent) =>
                                (props, value) => editableFields.indexOf("discount") !== -1 ?
                                    <TextInput type="decimal" name="discount" label={false} focus="focus"
                                               value={value}
                                               onKeyDown={(e, field, value) => {
                                                   ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                               }}
                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                    /> : false
                    },
                    "netsaleprice": {
                        header: 'Nettó e.ár',
                        width: 1,
                        renderer: CurrencyFormatter,
                        className: "currency",
                        editor:
                            (parent) =>
                                (props, value) => editableFields.indexOf("netsaleprice") !== -1 ?
                                    <TextInput type="decimal" name="netsaleprice" label={false} focus value={value}
                                               onKeyDown={(e, field, value) => {
                                                   ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                               }}
                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : false
                    },
                    "vat": {
                        header: "Áfa",
                        width: "vat",
                        renderer: (value) => <span className="vat">{value.name}</span>,
                        editor:
                            (parent) =>
                                (props, value) => editableFields.indexOf("vat") !== -1 ?
                                    <Select
                                        name="vat"
                                        component="vatrate"
                                        filter={{field: "active", value: 1}}
                                        objectValue={true}
                                        label={false}
                                        storeType="local"
                                        value={value}
                                        view={["rate"]}
                                        saveChanges={(field, value) => {
                                            parent.onEditorValueChange(props, value);
                                        }}
                                    /> : false
                    },
                    "saleprice": {
                        header: 'Bruttó e.ár',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: CurrencyFormatter,
                        className: "currency",
                        editor:
                            (parent) =>
                                (props, value) => editableFields.indexOf("saleprice") !== -1 ?
                                    <TextInput type="decimal" name="saleprice" label={false} focus value={value}
                                               onKeyDown={(e, field, value) => {
                                                   ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                               }}
                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : false
                    },
                    "qty": {
                        header: 'Db',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, row.unit),
                        className: "unit",
                        tooltip: (value, rowData, rowIndex, props) => {
                            return !props.isAggregation ? (rowData.instock < rowData.qty - (rowData.reserved || 0) && parseInt(this.props.values.state) < 120 ? "Készlethiány!" : "") : ""
                        },
                        columnClassName: (field, value, rowData, rows, props) => ({
                            "bold color": !props.isAggregation && (rowData.instock < rowData.qty - (rowData.reserved || 0)),
                            [!props.isAggregation && (rowData.instock < rowData.qty - (rowData.reserved || 0) ? (this.props.values.strict ? "danger" : "warning") : "success")]: parseInt(this.props.values.state) < 120
                        }),
                        editor:
                            (parent) =>
                                (props, value) => editableFields.indexOf("qty") !== -1 ?
                                    <TextInput type="number" name="qty" label={false} focus value={value}
                                               onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : false
                    },
                    ...( parseInt(this.props.values.state) < 120 && this.props.PointOfSale ? {
                        "qty_action": {
                            header: ' ',
                            width: 1,
                            renderer: (value, row) => {
                                let stockList = null;
                                return <OperationListStock productId={get(row, "product_id")} product={row}>
                                    <a className="btn btn-block btn-default btn-xs">
                                        Készlet
                                    </a>
                                </OperationListStock>;
                                return <Fragment>
                                    <a className="btn btn-block btn-default btn-xs" onClick={(e) => {
                                        e && e.preventDefault();
                                        stockList && stockList.focus();
                                    }}>
                                        Készlet
                                    </a>
                                    <Portal>
                                        <StockEditor
                                            gridid={null}
                                            list={
                                                (props) =>
                                                    <Modal
                                                        size="large"
                                                        ref={(e) => stockList = e}
                                                        {...props}
                                                        disabled={this.props.disabled || this.props.isLoading}
                                                        buttons={[
                                                            {
                                                                text: "Bezárás",
                                                                props: {
                                                                    color: "default",
                                                                    disabled: this.props.disabled || this.props.isLoading
                                                                },
                                                                onClose: true,
                                                                onClick: async () => {
                                                                    try {
                                                                        stockList && stockList.hide();
                                                                    } catch (e) {

                                                                    }
                                                                }
                                                            }
                                                        ]}
                                                    />
                                            }
                                            partner_id={this.props.PointOfSale.partner.partner_id}
                                            product_id={row.product_id}
                                        />
                                    </Portal>
                                </Fragment>;
                            }
                        }
                    } : {}),
                    "totalprice": {
                        header: 'Bruttó érték',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: CurrencyFormatter,
                        className: "currency",
                        editor:
                            (parent) =>
                                (props, value) => editableFields.indexOf("totalprice") !== -1 ?
                                    <TextInput type="decimal" name="totalprice" label={false} focus value={value}
                                               onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : false
                    },
                    ...(["410", "420"].indexOf(this.props.values.state + "") !== -1 ? {
                        "receivedqty": {
                            header: 'Beérkezett',
                            width: 1,
                            sortable,
                            filterable,
                            columnClassName: (field, value, rowData) => ({
                                "danger color": (parseInt(rowData.receivedqty || 0) - parseInt(rowData.qty || 0)) < 0,
                                "warning color": (parseInt(rowData.receivedqty || 0) - parseInt(rowData.qty || 0)) > 0,
                            }),
                            renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                            className: "unit"
                        },
                    } : {}),
                    ...(this.props.values.state < 120 ? {
                        "reserved": {
                            header: 'Lefoglalva',
                            width: 1,
                            sortable,
                            filterable,
                            renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                            className: "unit"
                        },
                        "instock": {
                            header: 'Készlet',
                            width: 1,
                            sortable,
                            filterable,
                            renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                            className: "unit"
                        }
                    } : {})
                }}
                {...(editableFields.indexOf("id") === -1 ? {listfield: "allitems"} : {name: "allitems"})}
                data={this.props.values}
                orderBy={{field: "name", direction: "ASC"}}
                componentConfig={this.props.componentConfig}
            />
        );
    }
}